export default __webpack_public_path__ + "static/media/choose1.b092ae66.png";